module.exports = __webpack_public_path__ + "img/1.4dca1172.png";